<template>
  <div class="infoboard-company">
		<div
			ref="type"
			class="infoboard-company__type"
		>
			<img :src="computedEnergyTypeLogo">
		</div>

		<div class="g-container g-container--pass-padding">
			<p class="g-text g-text--title">{{ rotationName }}</p>
			<p class="g-text">{{ textField }}</p>

			<img
				class="infoboard-company__logo"
				:src="logo"
			>
		</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'InfoboardCompany',
	props: {
		type: {
			type: String,
			default: ''
		},
		rotationType: {
			type: String,
			default: ''
		},
		rotationName: {
			type: String,
			default: ''
		},
		textField: {
			type: String,
			default: ''
		},
		logo: {
			type: String,
			default: ''
		},
	},
	data() {
		return {
			energyTypeIcons: {
				electricity: require('@images/energy-types/electricity.png'),
				water: require('@images/energy-types/water.png'),
				solar: require('@images/energy-types/solar.png'),
				heat: require('@images/energy-types/heat.png'),
				wind: require('@images/energy-types/wind.png'),
				chargingPoint: require('@images/energy-types/charging-point.png')
			} as {[key: string]: string}
		}
	},
	computed: {
		computedEnergyTypeLogo(): string {
			if (this.rotationType === 'single') {
				const icon = this.energyTypeIcons[this.type]

				if (!icon) {
					console.error('could not find icon', this.type, 'in', Object.keys(this.energyTypeIcons))
					return require('@images/energy-types/total.png')
				}

				return icon
			} else {
				return require('@images/energy-types/total.png')
			}
		}
	},
	watch: {
		computedEnergyTypeLogo: {
			handler() {
				this.$nextTick(() => { // ref is possibly undefined unless deferred
					const ref = this.$refs.type as HTMLElement
					ref.classList.remove('animation--fade')

					setTimeout(() => ref.classList.add('animation--fade'), 0)
				})
			},
			immediate: true
		}
	}
})
</script>

<style lang="scss">
.infoboard-company {
	&__type {
		opacity: 0;

		font-size: 100px;

		img {
			display: block;
			width: 60%;
			max-width: 90px;
			max-width: clamp(90px, 3.2vw, 170px);
			margin: 0 auto;
		}
	}
	&__logo {
		display: block;
		width: 100%;
		max-width: clamp(220px, 14vw, 420px);
		margin: 0 auto;
	}
}

@media (orientation: portrait) {
	.infoboard-company {
		&__logo {
			max-width: clamp(260px, 42vw, 720px);
		}
	}
}
</style>
